/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1LocationCountriesCountryidLangsMutationRequest,
  PostApiV1LocationCountriesCountryidLangsMutationResponse,
  PostApiV1LocationCountriesCountryidLangsPathParams,
  PostApiV1LocationCountriesCountryidLangs400,
  PostApiV1LocationCountriesCountryidLangs401,
  PostApiV1LocationCountriesCountryidLangs404,
  PostApiV1LocationCountriesCountryidLangs500,
} from "../../types/locationCountryLangController/PostApiV1LocationCountriesCountryidLangs.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1LocationCountriesCountryidLangs } from "../../clients/locationCountryLangController/postApiV1LocationCountriesCountryidLangs.ts";

export const postApiV1LocationCountriesCountryidLangsMutationKey = () =>
  [{ url: "/api/v1/location/countries/:countryId/langs" }] as const;

export type PostApiV1LocationCountriesCountryidLangsMutationKey = ReturnType<
  typeof postApiV1LocationCountriesCountryidLangsMutationKey
>;

export function postApiV1LocationCountriesCountryidLangsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiV1LocationCountriesCountryidLangsMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = postApiV1LocationCountriesCountryidLangsMutationKey();
  return mutationOptions<
    PostApiV1LocationCountriesCountryidLangsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1LocationCountriesCountryidLangs400
      | PostApiV1LocationCountriesCountryidLangs401
      | PostApiV1LocationCountriesCountryidLangs404
      | PostApiV1LocationCountriesCountryidLangs500
    >,
    {
      countryId: PostApiV1LocationCountriesCountryidLangsPathParams["countryId"];
      data?: PostApiV1LocationCountriesCountryidLangsMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ countryId, data }) => {
      return postApiV1LocationCountriesCountryidLangs(countryId, data, config);
    },
  });
}

/**
 * @description Cria uma nova tradução (idioma) para o país informado. **(Requer Authorization para autenticação)**
 * @summary Criar idioma do país (Requer Authorization para autenticação)
 * {@link /api/v1/location/countries/:countryId/langs}
 */
export function usePostApiV1LocationCountriesCountryidLangs<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1LocationCountriesCountryidLangsMutationResponse,
      ResponseErrorConfig<
        | PostApiV1LocationCountriesCountryidLangs400
        | PostApiV1LocationCountriesCountryidLangs401
        | PostApiV1LocationCountriesCountryidLangs404
        | PostApiV1LocationCountriesCountryidLangs500
      >,
      {
        countryId: PostApiV1LocationCountriesCountryidLangsPathParams["countryId"];
        data?: PostApiV1LocationCountriesCountryidLangsMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1LocationCountriesCountryidLangsMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1LocationCountriesCountryidLangsMutationKey();

  const baseOptions = postApiV1LocationCountriesCountryidLangsMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1LocationCountriesCountryidLangsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1LocationCountriesCountryidLangs400
      | PostApiV1LocationCountriesCountryidLangs401
      | PostApiV1LocationCountriesCountryidLangs404
      | PostApiV1LocationCountriesCountryidLangs500
    >,
    {
      countryId: PostApiV1LocationCountriesCountryidLangsPathParams["countryId"];
      data?: PostApiV1LocationCountriesCountryidLangsMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PostApiV1LocationCountriesCountryidLangsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1LocationCountriesCountryidLangs400
      | PostApiV1LocationCountriesCountryidLangs401
      | PostApiV1LocationCountriesCountryidLangs404
      | PostApiV1LocationCountriesCountryidLangs500
    >,
    {
      countryId: PostApiV1LocationCountriesCountryidLangsPathParams["countryId"];
      data?: PostApiV1LocationCountriesCountryidLangsMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1LocationCountriesCountryidLangsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1LocationCountriesCountryidLangs400
      | PostApiV1LocationCountriesCountryidLangs401
      | PostApiV1LocationCountriesCountryidLangs404
      | PostApiV1LocationCountriesCountryidLangs500
    >,
    {
      countryId: PostApiV1LocationCountriesCountryidLangsPathParams["countryId"];
      data?: PostApiV1LocationCountriesCountryidLangsMutationRequest;
    },
    TContext
  >;
}
